<template>
  <div id='footer'>Reloading in {{ secs_left }} seconds...</div>
</template>

<script>
  export default {
    name: 'reconnect',
    data: function() {
      return {
        secs_left: 5,
        interval: 0
      }
    },
    mounted: function() {
      var self = this
      this.interval = setInterval(function() {
        console.log( 'secs left are', self.secs_left )
        self.secs_left = self.secs_left - 1
        if ( self.secs_left <= 0 ) {
          location.reload()
        }
      }, 1000)
    },
    beforeDestroy: function() {
      if ( this.interval > 0) {
        clearInterval( this.interval )
      }
    }
  }
</script>

<style scoped>
.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: lightgray;
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// reconnect.vue?44ee3698